import React from 'react';
import { ArrowDirection } from '../../../icons/Arrow';
import { PaginationArrow } from './styled';
import Icon from '../../Icon';
import ArrowIcon from '../../../public/static/images/item/arrow-right.svg';

interface PaginationArrowButtonProps {
  disabled: boolean;
  direction: ArrowDirection;
  onClick?: () => void;
}

export const PaginationArrowButton: React.FC<PaginationArrowButtonProps> = ({
  disabled,
  direction,
  onClick
}) => (
  <PaginationArrow
    disabled={disabled}
    $direction={direction}
    onClick={onClick}
    data-cy={`pagination-arrow-${direction}`}
  >
    <Icon width={8} height={14} IconComponent={ArrowIcon} indent={false} />
  </PaginationArrow>
);
